
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Category, SubjectAggregate } from '@shared/models';

	@Component({})
	export default class TopCategoriesByCompany extends BaseView {

		public list: Array<SubjectAggregate<Category>> = new Array<SubjectAggregate<Category>>();

		/** Fires when this component is loaded */
		public async mounted() {
			this.loading = true;
			try {
				const companyId = this.$route.params.id;
				const results = await this.$api.categoryService.listByCompany(companyId, 0, 5);
				this.list = results.results;
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading the tag cloud');
			} finally {
				this.loading = false;
			}

		}

	}

